/**
 * Channel services that support grid view display.
 * Grid view shows post thumbnails in a visual grid layout,
 * which is most useful for image/video-heavy platforms.
 */
export const GRID_VIEW_SUPPORTED_SERVICES = new Set<string>([
  'tiktok',
  'youtube',
  'instagram',
])

/**
 * Checks if a channel service supports grid view display.
 * @param channelService - The channel service identifier (e.g., 'instagram', 'twitter')
 * @returns true if the service supports grid view
 */
export function isGridViewSupported(channelService?: string | null): boolean {
  return GRID_VIEW_SUPPORTED_SERVICES.has(channelService?.toLowerCase() ?? '')
}

type ChannelWithService = {
  service?: string | null
}

/**
 * Grid view is only available when every channel in the current scope supports it.
 */
export function doAllChannelsSupportGridView(
  channels: ChannelWithService[],
): boolean {
  if (channels.length === 0) {
    return false
  }

  return channels.every((channel) => isGridViewSupported(channel.service))
}
